import { parseInternalDatetime } from './time_utils';

export function setMomentStartStop(timeEntry, timeZone) {
  const startTime = parseInternalDatetime(timeEntry.start_time);
  const stopTime = parseInternalDatetime(timeEntry.stop_time);

  if (typeof timeZone === 'string') {
    startTime.tz(timeZone);
    stopTime.tz(timeZone);
  }

  return Object.assign({}, timeEntry, { start_time: startTime, stop_time: stopTime });
}
